import { createApp } from 'vue';
// import { createMetaManager, plugin as metaPlugin } from 'vue-meta';
import VueGtag from 'vue-gtag';
import VueScreen from 'vue-screen';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import 'babel-polyfill';

// ACYSOL-10348: This plugin was used for IVR project but IVR isn't used at all, and this plugin
// breaks Safari 14 and below on iOS, so DO NOT ENABLE unless you know what you are doing.
// const metaManager = createMetaManager();

const app = createApp(App)
  .use(store)
  .use(router)
  .use(i18n)
  // .use(metaManager)
  // .use(metaPlugin)
  .use(VueScreen)
  .use(VueGtag, {
    config: {
      id: `${process.env.VUE_APP_GOOGLE_ANALYTICS}`
    }
  });

app.mount('#app');
